// -- React and related libs
import React from "react";
import { useState , useEffect } from "react";
import { connect } from "react-redux";
import { Switch, Route, withRouter, Redirect } from "react-router";
import { useHistory } from 'react-router-dom';

// -- Third Party Libs
import PropTypes from "prop-types";

// -- Custom Components
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../Footer/Footer";
import Breadcrumbs from "../Breadbrumbs/Breadcrumbs";
import Dashboard from "../../pages/dashboard/Dashboard";
import ServiceDashboard from "../../pages/dashboard/serviceDashboard/serviceDashboard";
import Typography from "../../pages/typography/Typography";
import Notifications from "../../pages/notifications/Notifications";
import Task from "../../pages/tables/Task";
import Project from "../../pages/project/project";
import Complaints from "../../pages/complaints/complaints";
import Charts from "../../pages/uielements/charts/Charts";
import Icons from "../../pages/uielements/icons/IconsPage";
import Maps from "../../pages/uielements/maps/google/GoogleMapPage";
import User from "../../pages/User/user";
import Useradd from "../../pages/User/useradd";
import Useredit from "../../pages/User/useredit";
import Closedservices from "../../pages/subpages/closedservices";
import Product from "../../pages/subpages/product";
import Service from "../../pages/subpages/service";
import ServiceAdd from "../../pages/service/serviceAdd";
import ProjectPlanned from "../../pages/viewpages/projectPlanned";
import ProjectAwaiting from "../../pages/viewpages/projectAwaiting";
import ProjectCompleted from "../../pages/viewpages/projectCompleted";
import ProjectInProgress from "../../pages/viewpages/projectInProgress";
import projectTaskCompleted from "../../pages/viewpages/projectTaskCompleted";
import ProjectTaskPlanned from "../../pages/viewpages/projectTaskPlanned";
import ServiceRegistered from "../../pages/viewpages/serviceRegistered";
import ServiceRescheduled from "../../pages/viewpages/serviceRescheduled";
import ServiceReOpen from "../../pages/viewpages/serviceReOpen";
import ServicePlanned from "../../pages/viewpages/servicePlanned";
import ServiceClosed from "../../pages/viewpages/serviceClosed";
import ServiceAssigned from "../../pages/viewpages/serviceAssigned";
import ServiceResolve from "../../pages/viewpages/serviceResolve";
import Profile from "../../profilepage";
import ProfileUser from "../../profilepage_user";
import Snav from "../../components/secondNav/Snavbar";
import ProjectCancel from "../../pages/viewpages/projectCancel";



// -- Component Styles
import s from "./Layout.module.scss";

const Layout = (props) => {

  const headerStyle = {
position: "sticky",
  top: 0,
  zIndex: 1000,
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "left",
  padding: "0.5rem 1rem",
  };

  const history = useHistory();
  
  useEffect(() => {
    // Update local storage whenever customerId or companyId changes
    const isAuthenticated = localStorage.getItem('auth');
    if(!isAuthenticated) history.push('/login');
   
      return;
  }, []);

  
  const modules = JSON.parse(localStorage.getItem('modules'));
  const isProjectModuleEnabled = modules.some(module => module.P === 1 );
  const isServiceDashboardModuleEnabled = modules.some(module => module.S === 1);

  const areBothModulesEnabled = isProjectModuleEnabled && isServiceDashboardModuleEnabled;

  const role = localStorage.getItem('role').trim();
  
  return (
    <div className={s.root}>
      <div className={s.wrap}>
        <Header style={headerStyle} />
        <Sidebar />
        <Snav />
        <main className={s.content}>
          {/* <Breadcrumbs url={props.location.pathname} /> */}
          <Switch>
            {/* <Route path="/timeinlive" exact render={() => 
             <Redirect
             to={
               areBothModulesEnabled
                 ? '/timeinlive/dashboard'
                 : isProjectModuleEnabled
                 ? '/timeinlive/dashboard'
                 : isServiceDashboardModuleEnabled
                 ? '/timeinlive/serviceDashboard'
                 : '/fallbackRoute' // Neither module is enabled, replace with the fallback route
             }
           /> 
            
    //         <Redirect
    //   to={
    //     isProjectModuleEnabled
    //       ? '/timeinlive/dashboard'
    //       : isServiceDashboardModuleEnabled
    //       ? '/timeinlive/serviceDashboard'
    //       : '/fallbackRoute' // Replace with the fallback route if neither condition is met
    //   }
    // />
  }  /> */}

    
            <Route path="/timeinlive/profileAdmin" exact component={Profile}/>
            <Route path="/timeinlive/profileUser" exact component={ProfileUser}/>
            
            {!areBothModulesEnabled && isProjectModuleEnabled && role &&  (
               <>
               <Route path="/timeinlive/dashboard" exact component={Dashboard}/>
                <Route path="/timeinlive/project" exact component={Project} />
                <Route path="/timeinlive/Complaints" exact component={Complaints} />
                <Route path="/timeinlive/task" exact component={Task} />
                <Route path="/timeinlive/ProjectPlanned" exact component={ProjectPlanned}/>   
                <Route path="/timeinlive/ProjectAwaiting" exact component={ProjectAwaiting}/>
                <Route path="/timeinlive/ProjectCompleted" exact component={ProjectCompleted}/>
                <Route path="/timeinlive/ProjectInProgress" exact component={ProjectInProgress}/>
                <Route path="/timeinlive/projectTaskCompleted" exact component={projectTaskCompleted}/>
                <Route path="/timeinlive/ProjectTaskPlanned" exact component={ProjectTaskPlanned}/>
                <Route path="/timeinlive/ProjectCancel" exact component={ProjectCancel}/>
                <Route path="/timeinlive/User" exact component={User} />
                <Route path="/timeinlive/Useradd/" exact component={Useradd} />
              <Route path="/timeinlive/Useredit/:id" exact component={Useredit} />
               </>
)}
{!areBothModulesEnabled && isServiceDashboardModuleEnabled &&  role &&(
            <>
             <Route path="/timeinlive/serviceDashboard" exact component={ServiceDashboard}/>
            <Route path="/timeinlive/ServiceRegistered" exact component={ServiceRegistered}/> 
            <Route path="/timeinlive/ServiceRescheduled" exact component={ServiceRescheduled}/>
            <Route path="/timeinlive/ServiceReOpen" exact component={ServiceReOpen}/>
            <Route path="/timeinlive/ServicePlanned" exact component={ServicePlanned}/>
            <Route path="/timeinlive/ServiceClosed" exact component={ServiceClosed}/>      
            <Route path="/timeinlive/ServiceAssigned" exact component={ServiceAssigned}/>
            <Route path="/timeinlive/ServiceResolve" exact component={ServiceResolve}/>
            <Route path="/timeinlive/closedservices" exact component={Closedservices} />
            <Route path="/timeinlive/product" exact component={Product} />
            <Route path="/timeinlive/service" exact component={Service} />
            <Route path="/timeinlive/serviceadd" exact component={ServiceAdd}/>
            <Route path="/timeinlive/User" exact component={User} />
            <Route path="/timeinlive/Useradd/" exact component={Useradd} />
              <Route path="/timeinlive/Useredit/:id" exact component={Useredit} />
            </>
            )}

{!areBothModulesEnabled && isServiceDashboardModuleEnabled && role === "A" && (
            <>
              <Route path="/timeinlive/User" exact component={User} />
              <Route path="/timeinlive/Useradd/" exact component={Useradd} />
              <Route path="/timeinlive/Useredit/:id" exact component={Useredit} />
              <Route path="/timeinlive/map" exact component={Maps} />
              
            </>
          )} 


{areBothModulesEnabled && (
          <>
            <Route path="/timeinlive/dashboard" exact component={Dashboard} />
            <Route path="/timeinlive/project" exact component={Project} />
            <Route path="/timeinlive/Complaints" exact component={Complaints} />
            <Route path="/timeinlive/task" exact component={Task} />
            <Route path="/timeinlive/ProjectPlanned" exact component={ProjectPlanned} />
            <Route path="/timeinlive/ProjectAwaiting" exact component={ProjectAwaiting} />
            <Route path="/timeinlive/ProjectCompleted" exact component={ProjectCompleted} />
            <Route path="/timeinlive/ProjectInProgress" exact component={ProjectInProgress} />
            <Route path="/timeinlive/projectTaskCompleted" exact component={projectTaskCompleted} />
            <Route path="/timeinlive/ProjectTaskPlanned" exact component={ProjectTaskPlanned} />
            <Route path="/timeinlive/serviceDashboard" exact component={ServiceDashboard} />
            <Route path="/timeinlive/ServiceRegistered" exact component={ServiceRegistered} />
            <Route path="/timeinlive/ServiceRescheduled" exact component={ServiceRescheduled} />
            <Route path="/timeinlive/ServiceReOpen" exact component={ServiceReOpen} />
            <Route path="/timeinlive/ServicePlanned" exact component={ServicePlanned} />
            <Route path="/timeinlive/ServiceClosed" exact component={ServiceClosed} />
            <Route path="/timeinlive/ServiceAssigned" exact component={ServiceAssigned} />
            <Route path="/timeinlive/ServiceResolve" exact component={ServiceResolve} />
            <Route path="/timeinlive/closedservices" exact component={Closedservices} />
            <Route path="/timeinlive/product" exact component={Product} />
            <Route path="/timeinlive/service" exact component={Service} />
            <Route path="/timeinlive/User" exact component={User} />
              <Route path="/timeinlive/Useradd/" exact component={Useradd} />
              <Route path="/timeinlive/Useredit/:id" exact component={Useredit} />
              <Route path="/timeinlive/serviceadd" exact component={ServiceAdd}/>
              <Route path="/timeinlive/ProjectCancel" exact component={ProjectCancel}/>
          </>
        )}
            <Route path='*' exact render={() => <Redirect to="/error" />} />
          </Switch>
        </main>
        <Footer />
      </div>
      <Route path="/timeinlive" exact render={() => 
      <Redirect
        to={
          areBothModulesEnabled
            ? '/timeinlive/dashboard'
            : isProjectModuleEnabled
            ? '/timeinlive/dashboard'
            : isServiceDashboardModuleEnabled
            ? '/timeinlive/serviceDashboard'
            : '/timeinlive/dashboard' // Neither module is enabled, replace with the fallback route
        }
      />
    }  />
    </div>
  );
}

Layout.propTypes = {
  sidebarOpened: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
}

function mapStateToProps(store) {
  return {
    sidebarOpened: store.navigation.sidebarOpened,
  };
}

export default withRouter(connect(mapStateToProps)(Layout));
// export default Layout;
